import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from 'app/shared/services/user.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(public router: Router, public userService: UserService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (localStorage.getItem('userId')) {
      return true;
    } else {
      this.userService.userData = {};
      this.userService.userDataSignature = null;
      this.userService.networkData = null;

      this.router.navigate(['/login']);
      return false;
    }
  }
}
